import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import "@draft-js-plugins/mention/lib/plugin.css";
import reportWebVitals from "./reportWebVitals";
import {HashRouter, Route, Switch} from "react-router-dom";
import Admin from "./views/admin";
import {RoutePath} from "./router/routePath";
import LoginFailed from "./views/login/loginFailed";
import {AppConfig} from "./appConfig";
import {GrayLog} from "./grayLog/grayLog";

console.log(`Build date: ${AppConfig.buildDate} -`, AppConfig.envType)

GrayLog.initialize()

ReactDOM.render(
    <HashRouter>
        <Switch>
            <Route exact path={RoutePath.loginFailed} component={LoginFailed}/>
            <Route path={RoutePath.admin + ":token"} component={Admin}/>
        </Switch>
    </HashRouter>,
    document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
